import React, { Component, PropTypes } from 'react';
import { StoreOverviewStore, CategoryStore } from 'stores';
import { mixin, RefluxMixin } from 'Util';
import StoreFilter from 'components/Store/StoreFilter';
import Loader from 'components/Material/Loader';

class StoreFilterContainer extends mixin(RefluxMixin, Component) {
  static propTypes = {};

  listenToStores() {
    this.listenToStoreWithMapper(StoreOverviewStore, state => ({
      filter: state.filter
    }));
    this.listenToStoreWithMapper(CategoryStore, state => {
      return {
        categories: state.list,
        loading: state.loading
      };
    });
  }

  render() {
    const { loading, ...other } = this.state;
    if (loading) {
      return <Loader />;
    }
    return <StoreFilter {...other} {...this.props} />;
  }
}

export default StoreFilterContainer;



// WEBPACK FOOTER //
// ./src/js/containers/Store/StoreFilter.js